<template>
	<div id="app" :style="{'min-width': $route.path == '/pDetails' ? 'unset' : '1100px'}">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
	}
</script>

<style lang="scss" scoped>

</style>